const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
import { setCookie, getCookie } from '@/utils/commonUtils';

const getCookiesAccepted = () => (
  typeof document !== 'undefined' && getCookie('cookiesAccepted') === 'y' ? 'y' : 'n'
);

export const types = {
  /* COMMONS FOR EVERY WEB */
  SET_HEADER_VISIBILITY: 'UI/SET_HEADER_VISIBILITY',
  GET_TEXTS: 'UI/GET_TEXTS',
  SET_TEXTS: 'UI/SET_TEXTS',
  SET_LANGUAGE: 'UI/SET_LANGUAGE',
  SET_COOKIES_ACCEPTED: 'UI/SET_COOKIES_ACCEPTED',
  SEND_MAIL: 'UI/SEND_MAIL',
  SET_MAIL_RESULT: 'UI/SET_MAIL_RESULT',
  /* CLIENT REDUCERS */
  GET_ACTIVITIES: 'UI/GET_ACTIVITIES',
  SET_ACTIVITIES: 'UI/SET_ACTIVITIES',
  GET_FAQS: 'UI/GET_FAQS',
  SET_FAQS: 'UI/SET_FAQS',
  GET_BANNERS: 'UI/GET_BANNERS',
  SET_BANNERS: 'UI/SET_BANNERS',
  GET_PARAMS: 'UI/GET_PARAMS',
  SET_PARAMS: 'UI/SET_PARAMS',
}

export const initialState = {
  /* COMMONS */
  texts: null,
  language: 'es',
  cookiesAccepted: getCookiesAccepted(),
  headerVisible: true,
  contactMail: null,
  /* CLIENT */
  activities: null,
  faqs: null,
  banners: null,
  params: null,

}

const UIReducer = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE: {
      const { ui = {} } = action.payload || {};
      return {
        ...state,
        ...ui,
        // El estado SSR suele llegar como "n". No debe sobrescribir un
        // consentimiento que ya existe en el navegador.
        cookiesAccepted: state.cookiesAccepted === 'y' || ui.cookiesAccepted === 'y' ? 'y' : 'n',
      };
    }
    /* COMMON */
    case types.GET_TEXTS: { return { ...state } }
    case types.SET_TEXTS: { return { ...state, texts: action.texts } }
    case types.SET_COOKIES_ACCEPTED: {
      setCookie('cookiesAccepted', 'y', 365);
      return {
        ...state,
        cookiesAccepted: 'y',
      }
    }
    case types.SET_LANGUAGE: {
      const { language } = state;
      const newLanguageValue = language == 'es' ? 'en' : 'es';
      setCookie('language', newLanguageValue, 365);
      return {
        ...state,
        language: newLanguageValue,
      }
    }
    case types.SEND_MAIL: return {
      ...state,
      contactMail: {
        infoOp: '',
        operation: 'loading',
      },
    }
    case types.SET_MAIL_RESULT: return {
      ...state,
      contactMail: action.result,
    }
    case types.SET_HEADER_VISIBILITY: { return { ...state, headerVisible: action.payload } }
    /* Activities */
    case types.GET_ACTIVITIES: return { ...state }
    case types.SET_ACTIVITIES: {
      return { ...state, activities: action.activities }
    }
    /* Faqs */
    case types.GET_FAQS: return { ...state }
    case types.SET_FAQS: return { ...state, faqs: action.faqs }
    /* Banners */
    case types.GET_BANNERS: return { ...state }
    case types.SET_BANNERS: return { ...state, banners: action.banners }
    /* Params */
    case types.GET_PARAMS: return { ...state }
    case types.SET_PARAMS: return { ...state, params: action.params }    
    default: return state
  }
}

export const actions = {
  /* COMMON */
  setHeaderVisibility: flag => ({ type: types.SET_HEADER_VISIBILITY, payload: flag }),
  setLanguage: () => ({ type: types.SET_LANGUAGE }),
  getTexts: () => ({ type: types.GET_TEXTS }),
  setCookiesAccepted: () => ({ type: types.SET_COOKIES_ACCEPTED }),
  setTexts: texts => ({ type: types.SET_TEXTS, texts }),
  sendEmail: data => ({ type: types.SEND_MAIL, data }),
  setEmailResult: result => ({ type: types.SET_MAIL_RESULT, result }),
  /* Activities */
  getActivities: () => ({ type: types.GET_ACTIVITIES }),
  setActivities: activities => ({ type: types.SET_ACTIVITIES, activities }),
  /* Faq */
  getFaqs: () => ({ type: types.GET_FAQS }),
  setFaqs: faqs => ({ type: types.SET_FAQS, faqs }),
  /* Banners */
  getBanners: () => ({ type: types.GET_BANNERS }),
  setBanners: banners => ({ type: types.SET_BANNERS, banners }),
  /* Params */
  getParams: () => ({ type: types.GET_PARAMS }),
  setParams: params => ({ type: types.SET_PARAMS, params }),
}

export default UIReducer;
